var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.3999C9.69748 14.3999 11.3253 13.7257 12.5256 12.5254C13.7258 11.3252 14.4001 9.69732 14.4001 7.99994C14.4001 6.30255 13.7258 4.67469 12.5256 3.47445C11.3253 2.27422 9.69748 1.59994 8.0001 1.59994C6.30271 1.59994 4.67485 2.27422 3.47461 3.47445C2.27438 4.67469 1.6001 6.30255 1.6001 7.99994C1.6001 9.69732 2.27438 11.3252 3.47461 12.5254C4.67485 13.7257 6.30271 14.3999 8.0001 14.3999ZM8.8001 5.59994C8.8001 5.38776 8.71581 5.18428 8.56578 5.03425C8.41575 4.88422 8.21227 4.79994 8.0001 4.79994C7.78793 4.79994 7.58444 4.88422 7.43441 5.03425C7.28438 5.18428 7.2001 5.38776 7.2001 5.59994V7.19994H5.6001C5.38792 7.19994 5.18444 7.28422 5.03441 7.43425C4.88438 7.58428 4.8001 7.78777 4.8001 7.99994C4.8001 8.21211 4.88438 8.41559 5.03441 8.56562C5.18444 8.71565 5.38792 8.79994 5.6001 8.79994H7.2001V10.3999C7.2001 10.6121 7.28438 10.8156 7.43441 10.9656C7.58444 11.1157 7.78793 11.1999 8.0001 11.1999C8.21227 11.1999 8.41575 11.1157 8.56578 10.9656C8.71581 10.8156 8.8001 10.6121 8.8001 10.3999V8.79994H10.4001C10.6123 8.79994 10.8158 8.71565 10.9658 8.56562C11.1158 8.41559 11.2001 8.21211 11.2001 7.99994C11.2001 7.78777 11.1158 7.58428 10.9658 7.43425C10.8158 7.28422 10.6123 7.19994 10.4001 7.19994H8.8001V5.59994Z",
    fill: "#C649D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.efaf1a4b94891bdef0c2284c94367501.svg";
export { ForwardRef as ReactComponent };